// @ts-check

/**
 * Storefront link that carries a discount code (the storefront applies it at checkout) plus UTM tags
 * for measuring the traffic. Left without a country prefix on purpose: the storefront sends each
 * visitor to their own country and keeps the query string.
 * @param {{origin: string, code: string, productSlug?: string | null, source?: string, medium?: string, campaign?: string}} opts
 * @returns {string}
 */
export function buildCampaignLink({ origin, code, productSlug, source, medium, campaign }) {
  const base = origin.replace(/\/+$/, '');
  const path = productSlug ? `/product/${productSlug}` : '/';
  const params = new URLSearchParams();
  params.set('discount', code.trim().toUpperCase());
  if (source?.trim()) params.set('utm_source', source.trim());
  if (medium?.trim()) params.set('utm_medium', medium.trim());
  if (campaign?.trim()) params.set('utm_campaign', campaign.trim());
  return `${base}${path}?${params.toString()}`;
}
